import {Box, Col, Row} from 'components/Grid';
import style from './style.module.scss';
import Link from 'components/CustomRoutingLink';
import {createCopyrightString} from '../helpers';
import {PRIVACY_POLICY_ROUTE, RECOMMENDATION_TECHNOLOGIES_ROUTE, TERMS_ROUTE} from 'core/modules/routing/constants';
import {PRIVACY_EMAIL_HREF} from 'core/constants';
import {
    AGREEMENT_PLACEHOLDER_TEXT,
    PRIVACY_PLACEHOLDER_TEXT,
    RECOMMENDATION_TECHNOLOGIES_PLACEHOLDER_TEXT,
} from 'modules/footer/constants';

export const FooterCopyrights = () => {
    return (
        <div className={style.footerCopyrights}>
            <Box className={style.footerCopyrightsBox}>
                <Row>
                    <Col lg={12} sm={12}>
                        <div className={style.footerCopyrightsContainer}>
                            <div className={style.footerCopyrightsElement}>
                                <span className={style.text}>{createCopyrightString()}</span>
                            </div>
                            <div className={style.footerCopyrightsElement}>
                                <Link className={style.text} href={TERMS_ROUTE}>
                                    <span className={style.text}>{AGREEMENT_PLACEHOLDER_TEXT}</span>
                                </Link>
                            </div>
                            <div className={style.footerCopyrightsElement}>
                                <Link className={style.text} href={PRIVACY_POLICY_ROUTE}>
                                    <span className={style.text}>{PRIVACY_PLACEHOLDER_TEXT}</span>
                                </Link>
                            </div>
                            <div className={style.footerCopyrightsElement}>
                                <Link className={style.text} href={RECOMMENDATION_TECHNOLOGIES_ROUTE} target={'_blank'}>
                                    <span className={style.text}>{RECOMMENDATION_TECHNOLOGIES_PLACEHOLDER_TEXT}</span>
                                </Link>
                            </div>
                            <div className={style.footerCopyrightsElement}>
                                <span className={style.text}>
                                    По вопросам персональных данных:{' '}
                                    <Link className={style.privacyEMail} href={PRIVACY_EMAIL_HREF}>
                                        privacy@simple.ru
                                    </Link>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Box>
        </div>
    );
};
